export default "__VITE_ASSET__C4YUO9gw__"